<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @font-face {
    font-family: 'dana VF';
    src: url('/static_designers/fonts/dana/variable_fonts/variable2_webfont/dana2webGX.woff') format('woff-variations'),
    url('/static_designers/fonts/dana/variable_fonts/variable2_webfont/dana2webGX.woff') format('woff');
    font-display: fallback;
  }

  @font-face {
    font-family: dana;
    src: url('/static_designers/fonts/dana/variable_fonts/variable2_webfont/staticfonts/dana-regular.woff') format('woff');
  }
  @font-face {
    font-family: dana;
    src: url('/static_designers/fonts/dana/variable_fonts/variable2_webfont/staticfonts/dana-bold.woff') format('woff');
    font-weight: 700;
  }
body,
button,
input,
optgroup,
select,
textarea,
.ivu-modal-header-inner{
  font-family: dana, sans-serif!important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  font-family: dana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 5px;
}
.ivu-modal-close{
  left: 1px;
  right:auto
}
.ivu-modal-mask{
  z-index: 99999!important;
}
.ivu-modal-wrap{
  z-index: 999999!important;
}
.ivu-notice-with-desc .ivu-notice-icon{
  left:1px
}
.ivu-modal-header{
  padding: 14px 40px!important;
}
.ql-align-right,
.ql-align-right li,
.ql-align-left,
.ql-align-left li,
.ql{
  font-family: dana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.helper-desc img{
  width: 100%!important;
  max-width: 100%!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue